module.exports = __webpack_public_path__ + "static/media/HomeFurnishing3.1ae3dda6.png";